(function () {
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format || window.theme?.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function initKshetraPdp(section) {
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch {
      return;
    }

    const variantInput = section.querySelector('[data-ref="variantId"]');
    const priceEl = section.querySelector('[data-ref="priceDisplay"]');
    const atcLabel = section.querySelector('[data-ref="atcLabel"]');
    const atcBtn = section.querySelector('[data-ref="addToCartButton"]');
    const mainImage = section.querySelector('.kshetra-pdp__main-image');
    const mainImageWrap = section.querySelector('.kshetra-pdp__main-image-wrap');
    const thumbnails = section.querySelectorAll('.kshetra-pdp__thumbnail');
    const prevBtn = section.querySelector('[data-gallery-chevron="prev"]');
    const nextBtn = section.querySelector('[data-gallery-chevron="next"]');
    const pills = section.querySelectorAll('.kshetra-pdp__pill');
    const qtyInput = section.querySelector('.kshetra-pdp__qty-input');
    const minusBtn = section.querySelector('[data-qty-minus]');
    const plusBtn = section.querySelector('[data-qty-plus]');
    const atcBaseLabel = section.dataset.atcLabel || 'Add to Cart';

    let currentMediaIndex = 0;
    thumbnails.forEach((thumb, idx) => {
      if (thumb.classList.contains('is-active')) {
        currentMediaIndex = idx;
      }
    });

    function selectMedia(index) {
      if (!thumbnails.length) return;
      currentMediaIndex = (index + thumbnails.length) % thumbnails.length;

      thumbnails.forEach((thumb, i) => {
        const isSelected = i === currentMediaIndex;
        thumb.classList.toggle('is-active', isSelected);
        thumb.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        if (isSelected) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });

      const activeThumb = thumbnails[currentMediaIndex];
      if (activeThumb && mainImage) {
        const newSrc = activeThumb.dataset.mediaSrc;
        if (newSrc) {
          mainImage.style.opacity = '0.4';
          setTimeout(() => {
            mainImage.src = newSrc;
            mainImage.removeAttribute('srcset');
            mainImage.style.opacity = '1';
          }, 100);
        }
      }
    }

    thumbnails.forEach((thumb, i) => {
      thumb.addEventListener('click', () => selectMedia(i));
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        selectMedia(currentMediaIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        selectMedia(currentMediaIndex + 1);
      });
    }

    if (mainImageWrap && thumbnails.length > 1) {
      let touchStartX = 0;
      let touchEndX = 0;

      mainImageWrap.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mainImageWrap.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchEndX - touchStartX;
        if (Math.abs(diff) > 40) {
          if (diff < 0) {
            selectMedia(currentMediaIndex + 1);
          } else {
            selectMedia(currentMediaIndex - 1);
          }
        }
      }, { passive: true });
    }

    function getVariant(id) {
      return product.variants.find((v) => String(v.id) === String(id));
    }

    function selectVariant(variant) {
      if (!variant || !variantInput) return;

      variantInput.value = variant.id;
      let selectedPill = null;

      pills.forEach((pill) => {
        const isSelected = String(pill.dataset.variantId) === String(variant.id);
        pill.classList.toggle('is-selected', isSelected);
        if (isSelected) selectedPill = pill;
      });

      if (priceEl) {
        priceEl.textContent = selectedPill?.dataset.variantPrice || formatMoney(variant.price);
      }

      const badgeEl = section.querySelector('[data-kv-unit-price-badge]');
      if (badgeEl && variant) {
        const title = (variant.title || '').toLowerCase();
        const priceRupees = (variant.price || 0) / 100;
        let qty = 0;
        let unit = '';

        if (title.includes('kg')) {
          const m = title.match(/([\d.]+)\s*kg/);
          if (m) { qty = parseFloat(m[1]) * 1000; unit = 'g'; }
        } else if (title.includes('ml')) {
          const m = title.match(/([\d.]+)\s*ml/);
          if (m) { qty = parseFloat(m[1]); unit = 'ml'; }
        } else if (title.includes('gm')) {
          const m = title.match(/([\d.]+)\s*gm/);
          if (m) { qty = parseFloat(m[1]); unit = 'g'; }
        } else if (title.includes('g')) {
          const m = title.match(/([\d.]+)\s*g/);
          if (m) { qty = parseFloat(m[1]); unit = 'g'; }
        } else if (title.includes('l')) {
          const m = title.match(/([\d.]+)\s*l/);
          if (m) { qty = parseFloat(m[1]) * 1000; unit = 'ml'; }
        }

        if (qty === 0 && variant.weight > 0) {
          qty = parseFloat(variant.weight);
          unit = 'g';
        }

        if (qty > 0 && priceRupees > 0) {
          const rate = (priceRupees / qty).toFixed(2);
          badgeEl.textContent = `₹ ${rate} / ${unit}`;
          badgeEl.style.display = 'inline-block';
        } else {
          badgeEl.style.display = 'none';
        }
      }

      if (atcLabel) {
        const displayPrice = selectedPill?.dataset.variantPrice || formatMoney(variant.price);
        atcLabel.textContent = variant.available
          ? `${atcBaseLabel} — ${displayPrice}`
          : 'Sold out';
      }

      if (atcBtn) {
        atcBtn.disabled = !variant.available;
      }

      if (variant.featured_image && thumbnails.length) {
        let matchIndex = -1;
        thumbnails.forEach((thumb, idx) => {
          if (thumb.dataset.mediaId && String(thumb.dataset.mediaId) === String(variant.featured_image.id)) {
            matchIndex = idx;
          } else if (thumb.dataset.mediaSrc && variant.featured_image.src && variant.featured_image.src.includes(thumb.dataset.mediaSrc.split('?')[0])) {
            matchIndex = idx;
          }
        });
        if (matchIndex !== -1) {
          selectMedia(matchIndex);
        } else if (mainImage && variant.featured_image.src) {
          mainImage.src = variant.featured_image.src;
        }
      } else if (mainImage && variant.featured_image?.src) {
        mainImage.src = variant.featured_image.src;
        if (variant.featured_image.alt) mainImage.alt = variant.featured_image.alt;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const variant = getVariant(pill.dataset.variantId);
        if (variant) selectVariant(variant);
      });
    });

    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', () => {
        const min = parseInt(qtyInput.min, 10) || 1;
        const step = parseInt(qtyInput.step, 10) || 1;
        const val = parseInt(qtyInput.value, 10) || min;
        qtyInput.value = Math.max(min, val - step);
      });

      plusBtn.addEventListener('click', () => {
        const max = qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity;
        const step = parseInt(qtyInput.step, 10) || 1;
        const val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.min(max, val + step);
      });
    }

    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (variantId) {
      const variant = getVariant(variantId);
      if (variant) selectVariant(variant);
    }

    // Play video when visible on screen, pause when scrolled off screen
    const pdpVideos = section.querySelectorAll('.kshetra-pdp__video-wrap video');
    if (pdpVideos.length) {
      pdpVideos.forEach(v => {
        v.playsInline = true;
        v.setAttribute('playsinline', '');
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
              // Video is on screen -> play
              const p = video.play();
              if (p !== undefined) {
                p.catch(() => {
                  // Fallback if browser blocks unmuted play without user gesture
                  video.muted = true;
                  video.play().catch(() => {});
                });
              }
            } else {
              // Video is off screen -> pause
              video.pause();
            }
          });
        }, { threshold: 0.25 }); // Triggers when 25% of video is visible on screen

        pdpVideos.forEach(v => observer.observe(v));
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.kshetra-pdp').forEach(initKshetraPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.kshetra-pdp');
    if (section) initKshetraPdp(section.closest('.kshetra-pdp') || e.target);
  });
})();
